module.exports = __webpack_public_path__ + "img/library.ee52d262.png";